import { Component } from '@angular/core';
import { CourseCatalogueDetailsCardComponent } from '../../course-catalogue-details-card/course-catalogue-details-card.component';

@Component({
  selector: 'app-overnight-course-practical-exposition',
  standalone: true,
  imports: [CourseCatalogueDetailsCardComponent],
  templateUrl: './overnight-course-practical-exposition.component.html',
})
export class OvernightCoursePracticalExpositionComponent {
  morningItems = [
    { title: '7:30', description: $localize`Wake up` },
    { title: '8:00', description: $localize`Breakfast` },
    { title: '9:00', description: $localize`Theme activity*` },
    {
      title: '10:30',
      description: $localize`Break with cookie (provided by Skillz)`,
    },
    { title: '11:00', description: $localize`Game activity*` },
    { title: '12:30', description: $localize`Lunch break` },
  ];
  dayItems = [
    { title: '13:30', description: $localize`Theme activity*` },
    {
      title: '15:00',
      description: $localize`Break with fruit (provided by Skillz)`,
    },
    { title: '15:30', description: $localize`Game activity*` },
    { title: '17:00', description: $localize`Free moment and shower` },
    { title: '18:00', description: $localize`Dinner` },
    { title: '19:00', description: $localize`Evening activity` },
    { title: '21:00', description: $localize`Sleep` },
  ];
}
